export type EpSurveyTask = {
    id: string;
    title: string;
    status: 'open' | 'in_progress' | 'verified' | 'blocked';
    note: string;
    updatedAt?: string;
};

const task = (id: string, title: string): EpSurveyTask => ({ id, title, status: 'open', note: '' });
const journeyId = (origin: string, destination: string) => {
    const value = `${origin.trim().toLowerCase()}|${destination.trim().toLowerCase()}`;
    let hash = 2166136261;
    for (let index = 0; index < value.length; index++)
        hash = Math.imul(hash ^ value.charCodeAt(index), 16777619);
    return `route-${(hash >>> 0).toString(36)}`;
};

export function epSurveyGroundTasks(version: number, research?: any): EpSurveyTask[] {
    const tasks = [
        task('venue', 'Confirm venue location, access, exits, and site layout.'),
        task('medical', 'Confirm general hospital or trauma capability, AED access, and response times.'),
        task('safe-room', 'Inspect safe room location, door, locks, supplies, power, and communications.'),
        task('liaison', 'Confirm responder contacts, radio channels, and coordination.'),
    ];
    const journeys = Array.isArray(research?.journeys) ? research.journeys.slice(0, 20) : [];
    if (journeys.length)
        for (let index = 0; index < journeys.length; index++) {
            const origin = String(journeys[index].origin || '').slice(0, 120);
            const destination = String(journeys[index].destination || '').slice(0, 120);
            tasks.push(task(journeyId(origin, destination), `Drive or inspect journey ${index + 1}: ${origin} to ${destination}; confirm chokepoints and emergency options.`));
        }
    else
        tasks.push(task('routes', 'Drive or inspect critical journeys, chokepoints, and emergency options.'));
    if (version === 2 && research?.safeRoomRequired !== 'Yes')
        return tasks.filter(item => item.id !== 'safe-room');
    return tasks;
}

export function mergeEpSurveyTasks(expected: EpSurveyTask[], saved: unknown): EpSurveyTask[] {
    const previous = Array.isArray(saved) ? saved : [];
    return expected.map(item => {
        const match = previous.find((candidate: any) => candidate?.id === item.id);
        return match && ['open', 'in_progress', 'verified', 'blocked'].includes(match.status)
            ? { ...item, status: match.status, note: String(match.note || '').slice(0, 1000),
                ...(match.updatedAt ? { updatedAt: String(match.updatedAt).slice(0, 60) } : {}) } : item;
    });
}

export function epSurveyTaskAnnex(tasks: EpSurveyTask[]): string {
    return tasks.map(item => `${item.title}\nClient-reported status: ${item.status.replace('_', ' ')}${item.note ? `\nClient note: ${item.note}` : ''}`).join('\n\n');
}
